<template>
  <div class="container">
    <!-- <t-button
        type="button"
        class="btn btn-primary"
        v-modal="'choose-item'"
    >
      <i class="fas fa-plus"></i>
    </t-button> -->

    <t-table
      striped
      hover
      :show-empty="true"
      empty-text="No items"
      :items="localItems"
      :fields="localFields"
      v-on="$listeners"
    >
      <template slot="action" slot-scope="data">
        <div v-if="!data.item.saved">
          <button type="button" class="btn btn-primary">
            <i class="far fa-save"></i> Save
          </button>
        </div>
      </template>
    </t-table>

    <!-- <b-modal id="choose-item" v-on="$listeners">
      <slot name="pickerModal" :item="stagingItems"> </slot>
    </b-modal> -->
  </div>
</template>

<script type="text/javascript">
export default {
  props: {
    itemProvider: {
      type: Function,
      required: true,
    },

    apiUrl: {
      type: String,
      required: false,
    },

    fields: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      localItems: [],
      stagingItems: [],
    };
  },

  computed: {
    localFields() {
      this.fields.push(this.fields.length, 0, {
        key: "action",
        sortable: false,
      });

      return this.fields;
    },
  },

  methods: {
    addItems(items) {
      items.forEach(function (elem) {
        elem.saved = false;
      });

      this.localItems.push(items);
      this.stagingItems = [];

      return items;
    },

    removeItem(index, item) {
      return this.localItems.splice(index, 1, null);
    },
  },

  mounted() {
    let that = this;

    this.itemProvider(this, function (items) {
      items.map(function (elem) {
        return (elem.saved = true);
      });

      that.localItems = items;
    });
  },
};
</script>
